import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
export function ProcessSection() {
  const {
    t
  } = useLanguage();
  const steps = [{
    en: 'Schedule your visit',
    es: 'Agenda tu cita',
    descEn: 'Contact us to book your initial consultation.',
    descEs: 'Contáctanos para reservar tu consulta inicial.'
  }, {
    en: 'Medical history + goals review',
    es: 'Revisión de historial médico y objetivos',
    descEn: 'We discuss your health background and what you hope to achieve.',
    descEs: 'Discutimos tus antecedentes de salud y lo que esperas lograr.'
  }, {
    en: 'Discuss surgical and non-surgical options',
    es: 'Opciones quirúrgicas y no quirúrgicas',
    descEn: 'Review the best treatments tailored to your needs.',
    descEs: 'Revisamos los mejores tratamientos adaptados a tus necesidades.'
  }, {
    en: 'Pre-op testing and clearances',
    es: 'Estudios y autorizaciones',
    descEn: 'Complete necessary medical tests to ensure safety.',
    descEs: 'Completar las pruebas médicas necesarias para garantizar la seguridad.'
  }, {
    en: 'Procedure planning',
    es: 'Planificación del procedimiento',
    descEn: 'Prepare for your surgery date with clear instructions.',
    descEs: 'Preparación para la fecha de tu cirugía con instrucciones claras.'
  }, {
    en: 'Follow-up and long-term support',
    es: 'Seguimiento y apoyo a largo plazo',
    descEn: 'Ongoing care to help you maintain your results.',
    descEs: 'Atención continua para ayudarte a mantener tus resultados.'
  }];
  return <section className="py-16 md:py-24 bg-white overflow-hidden" data-id="element-164">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <div className="text-center mb-16" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-167">
            {t('The Consultation Process', 'El proceso de consulta')}
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-168">
            {t('A clear, structured path to better health.', 'Un camino claro y estructurado hacia una mejor salud.')}
          </p>
        </div>

        <div className="relative max-w-3xl mx-auto" data-id="element-169">
          {/* Vertical Line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-slate-200 transform md:-translate-x-1/2" data-id="element-170"></div>

          <div className="space-y-12" data-id="element-171">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`relative flex flex-col md:flex-row gap-8 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-172">
                {/* Timeline Dot */}
                <div className="absolute left-4 md:left-1/2 w-8 h-8 bg-teal-600 rounded-full border-4 border-white shadow-md transform -translate-x-1/2 flex items-center justify-center z-10" data-id="element-173">
                  <span className="text-white text-xs font-bold" data-id="element-174">
                    {index + 1}
                  </span>
                </div>

                {/* Content */}
                <div className={`ml-12 md:ml-0 md:w-1/2 ${index % 2 === 0 ? 'md:pl-12 text-left' : 'md:pr-12 md:text-right'}`} data-id="element-175">
                  <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-176">
                    {t(step.en, step.es)}
                  </h3>
                  <p className="text-slate-600" data-id="element-177">
                    {t(step.descEn, step.descEs)}
                  </p>
                </div>

                {/* Empty space for the other side */}
                <div className="hidden md:block md:w-1/2" data-id="element-178"></div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}